import React, { ReactElement } from 'react'
import CommonSectionItem, {
  CustomImage,
} from 'components/Organization/LandingPageCommonComponents/CommonSectionItem'
import ContentFilteringImage from 'images/organization/industries/schools/content-filtering.svg'
import UseCaseDivider from 'components/Organization/Industries/Common/UseCaseDivider'
import UseCaseItem from 'components/Organization/Industries/Common/UseCaseItem'
import ExposureToHarmfulContentIcon from 'images/organization/industries/schools/useCases/exposure.svg'
import ClassroomDistractionsIcon from 'images/organization/industries/schools/useCases/classroom.svg'
import CyberThreatsMalwareIcon from 'images/organization/industries/schools/useCases/cyber-threats.svg'
import ComplianceRisksIcon from 'images/organization/industries/schools/useCases/compliance-risks.svg'
import StyledLink from 'components/Organization/LandingPageCommonComponents/StyledLink'

export default function WhySchoolNeedContentFiltering(): ReactElement {
  return (
    <CommonSectionItem
      shouldMakeImageSticky
      customImage={
        <CustomImage
          svg={ContentFilteringImage}
          descriptiveText="Why schools need content filtering illustration"
        />
      }
      title="Why schools need content filtering"
      description="Schools are responsible for providing a safe, distraction-free digital learning environment, but unfiltered internet access poses major risks:"
      sx={{
        alignItems: 'flex-start',
        mt: '12rem',
        px: [0, '1.6rem', 0],
      }}
      useCases={
        <>
          <UseCaseDivider />
          <UseCaseItem
            svg={ExposureToHarmfulContentIcon}
            title="Exposure to Harmful Content"
            description="Students can access adult material, violence, and dangerous online communities."
          />
          <UseCaseDivider />
          <UseCaseItem
            svg={ClassroomDistractionsIcon}
            title="Classroom Distractions"
            description="Social media, gaming, and streaming reduce focus and academic performance."
          />
          <UseCaseDivider />
          <UseCaseItem
            svg={CyberThreatsMalwareIcon}
            title="Cyber Threats & Malware"
            description="Phishing attacks, ransomware, and malicious ads can compromise school networks."
          />
          <UseCaseDivider />
          <UseCaseItem
            svg={ComplianceRisksIcon}
            title="Compliance Risks"
            description={
              <>
                Schools must follow{' '}
                <StyledLink to="/blog/what-is-cipa">
                  CIPA (Children’s Internet Protection Act)
                </StyledLink>{' '}
                and other student privacy laws.
              </>
            }
          />
          <UseCaseDivider sx={{ mb: 0 }} />
        </>
      }
    />
  )
}
